import styled from "styled-components";

import Loader from "components/Layout/Loader";

export const Container = styled.div`
  width: 580px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  margin-top: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const SearchControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-left: 32px;
`;

export const SearchControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;
